<template>
  <sweet-modal title="" blocking width="940" ref="modal" class="modal" v-on:close="close">
    <div>
      <div style="text-align: right;">
        <h4>Transaction ID: {{transactionNo}}</h4>
      </div>
      <el-table
          size="mini"
          border
          stripe
          :data="items"
          style="width: 100%"
          @cell-click="cellClick">
        <el-table-column
            v-if="accountTypeId !== 15"
            label="Client">
          <template slot-scope="scope">
            {{scope.row.clientName}}
          </template>
        </el-table-column>
        <el-table-column
            v-if="accountTypeId !== 14"
            label="Vendor">
          <template slot-scope="scope">
            {{scope.row.vendorName}}
          </template>
        </el-table-column>
        <el-table-column width="100" :label="'Amount ' + money.suffix">
          <template slot-scope="scope">
            <div style="text-align: right;">{{formatPrice(scope.row.amount)}}</div>
          </template>
        </el-table-column>
        <el-table-column
            label="Description">
          <template slot-scope="scope">
            {{scope.row.transactionDescription}}
          </template>
        </el-table-column>
        <el-table-column
            label="Allocated To">
          <template slot-scope="scope">
            {{entityName(scope.row.entityTypeId)}}
          </template>
        </el-table-column>
        <el-table-column
            label="BU">
          <template slot-scope="scope">
            {{scope.row.buName}}
          </template>
        </el-table-column>
        <el-table-column
            label="WHS-ENG-PRO">
          <template slot-scope="scope">
            {{scope.row.entityName}}
          </template>
        </el-table-column>
        <el-table-column
            label="Task">
          <template slot-scope="scope">
            {{scope.row.taskName}}
          </template>
        </el-table-column>
        <el-table-column
            label="EU">
          <template slot-scope="scope">
            {{scope.row.userName}}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </sweet-modal>
</template>

<script>
import axios from 'axios'
import {SweetModal} from "@totalflow4/tfsweet-modal-vue";
import {Money, VMoney} from "v-money";
export default {
  name: "COAAllocationModal2",
  props: {
    accountTypeId: {
      type: Number,
      default: null
    }
  },
  components: {
    SweetModal,
    Money
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    }
  },
  data() {
    return {
      transactionNo: null,
      money: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      transaction: {},
      items: [],
      entityTypeList: [
        { id: 1, name: 'Project' },
        { id: 2, name: 'Business Unit' },
        { id: 3, name: 'Engagement' }
      ]
    }
  },
  methods: {
    async openModal(transaction) {
      this.transactionNo = transaction.transactionNo
      this.money.suffix = ' ' + this.companyLayout.currency.code
      this.transaction = transaction
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const item = await axios.get(`/api/v1/accountTransactionEntry/item?transactionId=${transaction.id}`)
        console.log('item', item.data)
        this.items = item.data.item.slice(0, -1);
        console.log(this.items)
        loader.hide()
        this.$refs.modal.open()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    cellClick(row) {
      console.log('row', row)
    },
    close() {
      this.money.suffix = ''
      this.transaction = {}
      this.items = []
      this.transactionNo = null
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    entityName(id) {
      return this.entityTypeList.find(val => val.id === id).name
    }
  }
}
</script>

<style scoped>

</style>
